export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13983.c838a029.jpg";